var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sharedome"},[_c('vue-qr',{attrs:{"size":220,"margin":10,"auto-color":true,"dot-scale":1,"text":_vm.appSrc}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }